import { useRef } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../components/psc/lib/SearchBox'
import GncDataTable from '../components/psc/lib/GncDataTable'

import useAuthentication from '../hooks/useAuthentication';
import useUserManagement from '../hooks/useUserManagement'
import useTableSlots from '../hooks/useTableSlots'
import useBrowserTabTitle from '../hooks/useBrowserTabTitle'

const SerialNumbers = () => {
    useBrowserTabTitle('Serial Numbers')

    const table = useRef(null)
    const urlGetData = '/v0/serial_numbers'
    const localStorageOrderKey = 'tblSerialNumbersOrder'
    const defaultOrder = [[ 2, 'desc' ]]
    
    const { currentUser } = useAuthentication();

    const {
        userHasRole,
        userHasProjectAccess,
    } = useUserManagement()

    const {
        dateSlot,
        linkSlot,
    } = useTableSlots()
    
    const columns = [
        { data: 'created_at' },
        { data: 'reference' },
        { data: 'title' },
        { data: 'ci_number' },
        { data: 'project.name' },
    ]
    const tableHead = (
        <tr>
            <th>Added</th>
            <th>Reference</th>
            <th>Title</th>
            <th>CI number</th>
            <th>Project</th>
        </tr>
    )

    const tableSlots = {
        0: dateSlot,
        1: (data, type, row) => userHasProjectAccess(currentUser, row.project_id) ? linkSlot(data, type, row, `/serial_numbers/${row.id}`) : data,
        2: (data, type, row) => userHasProjectAccess(currentUser, row.project_id) ? linkSlot(data, type, row, `/serial_numbers/${row.id}`) : data,
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">

                        <div className="ibox-title">
                            <h2>Serial Numbers</h2>

                            { userHasRole(currentUser, 'serial_numbers_user') &&
                              <Link type="button" className="btn btn-mr btn-primary" to="/serial_numbers/new">New Serial Number</Link>
                            }
                        </div>

                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />

                                <div className="col-sm-6 m-b-xs">
                                </div>
                            </div>

                            <GncDataTable
                                    tableRef={table}
                                    dataUrl={urlGetData}
                                    defaultOrder={defaultOrder}
                                    localStorageOrderKey={localStorageOrderKey}
                                    columns={columns}
                                    tableSlots={tableSlots}
                                    tableHead={tableHead}
                                    tableFoot={tableHead}
                                />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default SerialNumbers
